module.exports = __webpack_public_path__ + "img/slide_one.4ed60940.jpg";